import { render } from "./CreatePatientForm.vue?vue&type=template&id=6a820084&scoped=true"
import script from "./CreatePatientForm.vue?vue&type=script&lang=js"
export * from "./CreatePatientForm.vue?vue&type=script&lang=js"

import "./CreatePatientForm.vue?vue&type=style&index=0&id=6a820084&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a820084"]])

export default __exports__